export default "__VITE_ASSET__UuapdyfC__"